import { useMemo, useRef } from 'react';
import * as ReactFlow from '@xyflow/react';
import { Tag, Typography } from "antd";

import { IItemComparison } from "../../../../../../SimuladorInteligente/interfaces"
import { NodeToLinkData } from '../../../../..';
import AddLinkedNodeButton from '../../../../AddLinkedNodeButton';
import { CustomNode } from '../../../../../interfaces';

const HandleComponent = ReactFlow.Handle;

interface IProps {
  comparison: IItemComparison;
  node: CustomNode;
  onPressAddLinkedNode: (data: NodeToLinkData) => void;
}

export default function Comparison({
  comparison,
  node,
  onPressAddLinkedNode,
}: IProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  const connections = ReactFlow.useNodeConnections({
    id: node.id,
    handleId: comparison.id,
    handleType: "source",
  });

  const isConnectable = useMemo(() => {
    return connections.length === 0;
  }, [connections]);

  return (
    <div
      ref={containerRef}
      style={{
        position: 'relative',
        paddingTop: 8,
        paddingBottom: 8,
        paddingRight: 16,
        borderBottom: "1px solid #cdcdcd",
      }}
    >
      <Typography.Text>
        {comparison.title}
      </Typography.Text>

      {
        comparison.order !== undefined && (
          <Tag
            color='cyan'
            style={{
              marginLeft: 8,
              fontSize: 14
            }}
          >
            o/: {comparison.order}
          </Tag>
        )
      }

      <HandleComponent
        id={comparison.id}
        type="source"
        position={ReactFlow.Position.Right}
        isConnectable={isConnectable}
      />

      {
        isConnectable && (
          <AddLinkedNodeButton
            onPress={() => {
              onPressAddLinkedNode?.({
                source: node.id,
                sourceHandle: comparison.id,
                parentPosition: {
                  x: node.positionAbsoluteX,
                  y: node.positionAbsoluteY,
                },
                parentWidth: node.width,
                offsetTop: containerRef.current?.offsetTop,
              })
            }}
            style={{
              right: -50,
            }}
          />
        )
      }
    </div>
  )
}
